<!--
 * @Description: 教师教学考核 考核项目 评价预览
 * @Author: PF
 * @Date: 2025-03-27 10:43:36
 * @LastEditors: PF
 * @LastEditTime: 2025-03-28 16:10:47
-->
<template>
  <div>
    <el-dialog class="wp80 hp85" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">预览</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openList', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="评价内容" label-align="right" align="left" width="100px" span="2">{{khnrData.khxmnr}}</el-descriptions-item>
        <el-descriptions-item label="评价指标" label-align="right" align="left" width="100px" span="2">
          <p v-for="(item, index) in khnrData.listZb" :key="index">{{ item.khzb }}</p>
        </el-descriptions-item>
        <el-descriptions-item label="评分" label-align="right" align="left" width="100px" span="2" v-if="khnrData.dfxx">{{khnrData.dfxx}}</el-descriptions-item>
        <el-descriptions-item label="考核人" label-align="right" align="left" width="100px" span="2">{{khnrData.khrmc}}</el-descriptions-item>
        <el-descriptions-item label="评价人" label-align="right" align="left" width="100px" span="2">{{khnrData.pjrmc}}</el-descriptions-item>
        <el-descriptions-item label="是否已评分" label-align="right" align="left" width="100px" span="2">
          <span v-if="khnrData.sfypf">已评分</span>
          <span v-else>未评分</span>
        </el-descriptions-item>
      </el-descriptions>

      <el-divider v-if="pffs===1">评分选项</el-divider>
      <el-table v-if="pffs===1" :data="pfxxData" border :show-header="false">
        <el-table-column label="序号" type="index" width="80" fixed align="center" />
        <el-table-column label="评价类别" prop="pfx" align="center" />
        <el-table-column label="评分项值" prop="pfxsx" align="center" />
      </el-table>
      <div v-else>
        <el-descriptions :column="2" border v-for="(item, index) in pfxxData" :key="index">
          <el-descriptions-item label="设计公式" label-align="right" align="left" width="100px" span="2">{{item.pfgs}}</el-descriptions-item>
          <el-descriptions-item label="公式描述" label-align="right" align="left" width="100px" span="2">{{item.pfgsms}}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>
  </div>
</template>
<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import {
  closeWindow,
  actionPost
} from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo'
const props = defineProps({
  openList: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openList', 'ReturnData'])

const loading = ref(false)
const khnrData = ref({}) // 考核内容
const pfxxData = ref([]) // 评分选项
const pffs = ref() // 评分方式：1-选项，2-公式

watch(
  () => props.openList,
  () => {
    if (props.openList) {
      khnrData.value = {}
      pfxxData.value = []
      loading.value = true
      actionPost({
        url: `/api/v2/kaohexiangmu/kaohexiangmu/getkaoheneirong/pingfen/${props.row.id}`,
        data: {}
      }).then((res) => {
        loading.value = false
        if (res.code === 200) {
          khnrData.value = res.data.data
          pfxxData.value = res.data.bz
          pffs.value = res.data.pffs
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)

</script>
